import styled from "styled-components";
import { motion } from "framer-motion";

export const ContainerTurnosRecep = styled(motion.div)`
  width: 100vw;
  height: calc(100vh - 205px);
  display: flex;
  flex-direction: column;
  text-align: center;
  overflow-y: scroll;
  margin-top: 30px;
  gap: 10px;
  align-items: center;
`;

export const ContainerCardRecep = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 30px;
  padding-top: 30px;
  padding-bottom: 120px;
  overflow: auto;
  height: 100%;
  align-items: center;
  ::-webkit-scrollbar {
    width: 10px;
  }
  ::-webkit-scrollbar-thumb {
    -webkit-border-radius: 10px;
    border-radius: 10px;
    background: var(--color-scrollbar);
  }

  .turnos {
    width: 276px;
    height: 53px;
    border-radius: 8px;
    margin: auto;
    background: var(--color-latex30);
    color: var(--color-white);
    font-weight: 700;
    font-size: 18px;
  }
  .message {
    width: 286px;
    height: 95px;
    margin: auto;
    border: 2px solid var(--color-broccoli);
    color: var(--color-broccoli);
    font-size: 18px;
    border-radius: 8px;
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
    padding: 5px;
  }
`;

export const ContenidoPendiente = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  gap: 20px;
  button {
    width: 300px;
    height: 38px;
    background-color: var(--color-primary);
    border-radius: 8px;
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 20px;
    color: var(--color-white);
    font-size: 18px;
  }
  span {
    font-weight: 600;
    font-size: 18px;
  }
`;
export const BtnColaVirtual = styled.button`
  width: 216px;
  height: 52px;
  color: white;
  background: var(--color-latex30);
  border-radius: 8px;
`;
